import { render, staticRenderFns } from "./RewardHistory.vue?vue&type=template&id=270c60c7&scoped=true&"
import script from "./RewardHistory.vue?vue&type=script&lang=js&"
export * from "./RewardHistory.vue?vue&type=script&lang=js&"
import style0 from "./RewardHistory.vue?vue&type=style&index=0&id=270c60c7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270c60c7",
  null
  
)

export default component.exports